import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect, useCallback, useContext } from 'react';
import "../index.css";
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import axios from 'axios';
import { ProductContext } from "../context/AppContext";
import Footer from './Common_Components/Footer';
const authToken = localStorage.getItem("AuthToken");

function LectureVideo() {

    const location = useLocation();
    const [activePage, setActivePage] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [Learningdata, setLearningData] = useState();
    const SelectLanguageLocal = localStorage.getItem("selectedLanguage");

    const navigate = useNavigate();
    const day = location.state?.day || "Day Module";
    const categoryData = location.state;

    const ModuleId =
        categoryData?.ModuleId ||
        localStorage.getItem("ModuleId") ||
        localStorage.getItem("LearningJourneyActiveModuleId");
    const LearningId =
        categoryData?.LearningId ||
        localStorage.getItem("LearningId") ||
        localStorage.getItem("LearningJourneyActiveLearningMethodId");
    const screenTitleId =
        categoryData?.screenTitleId ||
        localStorage.getItem("screenTitleId") ||
        localStorage.getItem("LearningJourneyActiveScreenId");
    const examId =
        categoryData?.examId ||
        localStorage.getItem("examId") ||
        localStorage.getItem("selectedExamId");
    const day_learning_method_id =
        categoryData?.day_learning_method_id ||
        localStorage.getItem("day_learning_method_id") ||
        localStorage.getItem("LearningJourneyActiveLearningMethodId");
    const resolvedUniqueDayId =
        categoryData?.unique_day_id ||
        categoryData?.ModuleId ||
        localStorage.getItem("ModuleId") ||
        localStorage.getItem("LearningJourneyActiveModuleId");
    console.log("Leacture Data :", day_learning_method_id)
    const { Translate } = useContext(ProductContext);

    // console.log("this is learning id ", day_learning_method_id)

    useEffect(() => {
        const postVisit = async () => {
            if (!ModuleId || !LearningId || !screenTitleId || !examId || !resolvedUniqueDayId) {
                console.warn("Skipping lecture visit log due to missing data", {
                    ModuleId,
                    LearningId,
                    screenTitleId,
                    examId,
                    day_learning_method_id,
                    resolvedUniqueDayId,
                });
                return;
            }

            try {
                const token = localStorage.getItem("AuthToken");
                if (!token) {
                    return;
                }

                const response = await fetch(`https://api.japaking.online/api/user-visits/log-visit`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        id: ModuleId,
                        unique_day_id: resolvedUniqueDayId,
                        learning_method_id: LearningId,
                        screen_title_id: screenTitleId,
                        examId,
                        day_learning_method_id,
                    }),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
            } catch (error) {
                console.log("Error posting lecture visit:", error);
            }
        };

        postVisit();

        const getQuizTypeDetails = async () => {
            try {
                // Retrieve the token from AsyncStorage
                const authToken = localStorage.getItem("AuthToken");
                // console.log(authToken, 'authToken Home Page');
                // Alert.alert(authToken || 'No Token Found', 'authToken Home Page');

                if (!authToken) {
                    console.error('No Auth Token found');
                    return;
                }

                // Make the API call with the token in headers
                const response = await axios.get(`https://api.japaking.online/api/lecture/${day_learning_method_id}`, {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                });


                if (response?.data?.success) {
                    setLearningData(response?.data?.message?.video);
                }

            } catch (err) {
                console.error('API error:', err);

                // Handle unauthorized error
                if (err.response && err.response.status === 401) {
                    console.log('navigate to login due to 401');
                    navigate('/login');
                }
            }
        };

        getQuizTypeDetails();
    }, [ModuleId, LearningId, screenTitleId, examId, day_learning_method_id, navigate]);


    const [selectedLanguage, setSelectedLanguage] = useState('');
    // const SelectLanguageLocal = localStorage.getItem("selectedLanguage");
    const [isLoadingImage, setIsLoadingImage] = useState(true);
    if (isLoadingImage) {

    }

    const handleFinish = async () => {
        try {
            const token = localStorage.getItem("AuthToken");
            const baseUrl = process.env.REACT_APP_BASE_URL || "https://api.japaking.online";
            if (token && ModuleId && LearningId && screenTitleId && examId && resolvedUniqueDayId) {
                const response = await fetch(`${baseUrl}/api/user-visits/finish-visit`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        id: ModuleId,
                        unique_day_id: resolvedUniqueDayId,
                        learning_method_id: LearningId,
                        screen_title_id: screenTitleId,
                        examId,
                    }),
                });
                if (!response.ok) {
                    console.error("Failed to finish visit:", response.status);
                }
            }
        } catch (error) {
            console.error("Error calling finish-visit:", error);
        }

        navigate("/new-learning-journey", {
            state: {
                selectedExamId: examId,
                examId: examId,
                examTypes: categoryData?.examTypes || [],
            },
        });
    };

    return (
        <div className='Profile_Design_Main_Div_11'>
            <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                             <ArrowBackIosIcon onClick={() => navigate('/new-learning-journey')} className='icon_1' />
                            <h2>{Translate?.message?.data?.lectureVideo || "Lecture Video"}</h2>
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="tiles-wrapper">
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className="lecture-video">
                                {Learningdata && Learningdata[0] ? (
                                    <video
                                        className="lecture-video-player"
                                        src={isLoadingImage ? `${process.env.PUBLIC_URL}/assets/images/loading.png` : Learningdata[0].video_url}
                                        onLoadedData={() => setIsLoadingImage(false)} // Fires when video metadata has been loaded
                                        onError={() => setIsLoadingImage(false)} // Fires if video loading fails
                                        controls
                                        controlsList="nodownload"
                                    >
                                        Your browser does not support the video tag.
                                    </video>
                                ) : (
                                    <div>
                                        <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/loading.png`}
                                            alt="Loading..."
                                            className="lecture-video-placeholder"
                                        />
                                        <p></p>
                                    </div>
                                )}
                            </div>

                            <div className="lecture-finish-btn-container">
                                <button className="lecture-finish-btn" onClick={handleFinish}>
                                    {Translate?.message?.data?.finish || "Finish"}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {/* Footer Section */}
                  <Footer />

            {/* CSS for responsiveness */}
            <style jsx>{`
                /* Mobile-first design */
                .lecture-video-player {
                    width: 100%;
                    max-width: 100%;
                    height: auto;
                    border-radius: 10px;
                    margin-bottom: 20px;
                }

                .lecture-finish-btn-container {
                    display: flex;
                    justify-content: center;
                    margin-top: 20px;
                    margin-bottom: 20px;
                }

                .lecture-finish-btn {
                    background-color: #ffc0cb;
                    color: #fff;
                    border: none;
                    border-radius: 25px;
                    padding: 12px 40px;
                    font-size: 18px;
                    font-weight: bold;
                    cursor: pointer;
                    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
                    transition: all 0.3s ease;
                }

                .lecture-finish-btn:hover {
                    background-color: #ffb6c1;
                    transform: scale(1.05);
                }

                .footer-design-inner {
                    background-color: #fff;
                    position: fixed;
                    bottom: 0;
                    width: 100%;
                    padding: 10px;
                }

                .footer_icon_inner {
                    font-size: 24px;
                }

                /* Media queries for responsiveness */
                @media (max-width: 767px) {
                    .footer_Text_inner {
                        font-size: 14px;
                    }

                    .footer_icon_inner {
                        font-size: 20px;
                    }

                    .Profile_Design_Main_Div_11 {
                        padding: 10px;
                    }

                    .header_inner h2 {
                        font-size: 20px;
                    }

                    .tiles-wrapper {
                        padding: 0;
                    }
                }

                @media (max-width: 576px) {
                    .footer_Text_inner {
                        font-size: 12px;
                    }

                    .footer_icon_inner {
                        font-size: 18px;
                    }

                    .header_inner h2 {
                        font-size: 18px;
                    }

                    .footer-design-inner {
                        padding: 5px;
                    }
                }
            `}</style>
        </div>
    );
}

export default LectureVideo;
